import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import CampaignInsights from '@/components/v3/overview/CampaignInsights.vue';
import FbBusinessLoginButton from '@/components/auth/FbBusinessLoginButton.vue';
import BusinessLoginStatus from '@/plugins/graphql/queries/v2/business-login-status.gql';
let TermsAndAgreement = class TermsAndAgreement extends Mixins(ViewportSizeMixin, RouterParamsAppMixin) {
    goToCreateAd() {
        this.$router.push({
            name: 'create-ad',
            params: { uuid: this.appUUID, to: 'create-ad' },
        });
    }
    refetchBusinessLoginStatus() {
        this.$apollo.queries.businessLoginStatus.refetch();
    }
};
TermsAndAgreement = __decorate([
    Component({
        components: {
            PageTitle,
            ActionButton,
            CampaignInsights,
            FbBusinessLoginButton,
        },
        apollo: {
            businessLoginStatus: {
                query: BusinessLoginStatus,
                variables() {
                    return {
                        appUuid: this.$route.params.appUUID,
                    };
                },
                update(data) {
                    return data.app.systemUserAccessToken;
                },
                fetchPolicy: 'network-only',
            },
        },
    })
], TermsAndAgreement);
export default TermsAndAgreement;
